import React from 'react';

import AdjustCoinsTool from './AdjustCoinsTool';

const WalletTools = ({
  userId
}) => {
  return (
    <React.Fragment>
      <AdjustCoinsTool
        toolLabel='Add Free Coins'
        toolClass='Badge Badge--green Badge--spaced'
        createBtnText='Add Free Coins'
        coinType='free'
        endPoint={`/${gon.currentProvider}/users/${userId}/wallet/add`}
      />
      <AdjustCoinsTool
        toolLabel='Deduct Free Coins'
        toolClass='Badge Badge--red Badge--spaced'
        createBtnText='Deduct Free Coins'
        coinType='free'
        endPoint={`/${gon.currentProvider}/users/${userId}/wallet/deduct`}
      />
    </React.Fragment>
  )
}

export default WalletTools
